import UrlHandlerApiService from "../services/url-handler.service";
import { getToken } from "../services/jwt.service";

const JwtService = {
  async init() {
    const url = await UrlHandlerApiService.getBaseUrl();
    const isProduction = url.includes("prod");
    return isProduction;
  },

  /**
   * Decode JWT token and extract payload
   * @param {string} token - JWT token
   * @returns {object|null} - Decoded payload or null if invalid
   */
  decodeToken(token) {
    try {
      if (!token) return null;

      // JWT has 3 parts separated by dots: header.payload.signature
      const parts = token.split(".");
      if (parts.length !== 3) return null;

      // Decode the payload (second part)
      const payload = parts[1];

      // Add padding if needed for base64 decoding
      const paddedPayload = payload + "=".repeat((4 - (payload.length % 4)) % 4);

      // Decode base64
      const decodedPayload = atob(paddedPayload);

      // Parse JSON
      return JSON.parse(decodedPayload);
    } catch (error) {
      console.error("Error decoding JWT token:", error);
      return null;
    }
  },

  /**
   * Get ooblee_user_id from JWT token
   * @param {string} token - JWT token
   * @returns {number|null} - User ID or null if not found
   */
  getOobleeUserId(token) {
    const payload = this.decodeToken(token);
    return payload?.ooblee_user_id || null;
  },

  /**
   * Check if current user has finance access (user ID === 103274)
   * Only applies restriction in production environment
   * @param {string} token - JWT token
   * @returns {boolean} - True if user has finance access
   */
  async hasFinanceAccess(token) {
    // In development, allow access for all users
    const isProduction = await this.init();

    if (!isProduction) {
      return true;
    }

    // In production, only allow access for user ID 103274 (Jovan) | 112946 (Dorka) | 104987 (Filip) | 114856 (Romek)
    const userId = this.getOobleeUserId(token);
    return userId === 103274 || userId === 112946 || userId === 104987 || userId === 114856;
  },

  /**
   * Check if current logged-in user has finance access
   * @returns {boolean} - True if user has finance access
   */
  async currentUserHasFinanceAccess() {
    const token = getToken();
    return await this.hasFinanceAccess(token);
  }
};

export default JwtService;
